export default [
    {
        key: 'default',
        titleKey: 'canvas.size.default',
        lists: [
            {
                width: 1920,
                height: 1080,
                w: 16,
                h: 9,
            },
            {
                width: 1920,
                height: 1280,
                w: 3,
                h: 2,
            },
            {
                width: 1920,
                height: 1440,
                w: 4,
                h: 3,
            },
            {
                width: 1920,
                height: 1536,
                w: 5,
                h: 4,
            },
            {
                width: 1920,
                height: 1920,
                w: 1,
                h: 1,
            },
            {
                width: 1080,
                height: 1350,
                w: 4,
                h: 5,
            },
            {
                width: 1080,
                height: 1440,
                w: 3,
                h: 4,
            },
            {
                width: 1080,
                height: 1620,
                w: 2,
                h: 3,
            },
            {
                width: 1080,
                height: 1920,
                w: 9,
                h: 16,
            },
        ],
    },
    {
        key: 'facebook',
        titleKey: 'canvas.size.socialMedia.facebook',
        lists: [
            {
                titleKey: 'canvas.size.socialMedia.facebook.post',
                width: 1200,
                height: 630,
                w: 1.91,
                h: 1,
            },
            {
                titleKey: 'canvas.size.socialMedia.facebook.cover',
                width: 1640,
                height: 859,
                w: 1.91,
                h: 1,
            },
            {
                titleKey: 'canvas.size.socialMedia.facebook.story',
                width: 1080,
                height: 1920,
                w: 9,
                h: 16,
            },
            {
                titleKey: 'canvas.size.socialMedia.facebook.profile',
                width: 400,
                height: 400,
                w: 1,
                h: 1,
            }
        ],
    },
    {
        key: 'instagram',
        titleKey: 'canvas.size.socialMedia.instagram',
        lists: [
            {
                titleKey: 'canvas.size.socialMedia.instagram.post',
                width: 1080,
                height: 1080,
                w: 1,
                h: 1,
            },
            {
                titleKey: 'canvas.size.socialMedia.instagram.story',
                width: 1080,
                height: 1920,
                w: 9,
                h: 16,
            },
            {
                titleKey: 'canvas.size.socialMedia.instagram.portrait',
                width: 1080,
                height: 1350,
                w: 4,
                h: 5,
            },
            {
                titleKey: 'canvas.size.socialMedia.instagram.landscape',
                width: 1080,
                height: 566,
                w: 1.91,
                h: 1,
            }
        ],
    },
    {
        key: 'twitter',
        titleKey: 'canvas.size.socialMedia.twitter',
        lists: [
            {
                titleKey: 'canvas.size.socialMedia.twitter.post',
                width: 1200,
                height: 675,
                w: 16,
                h: 9,
            },
            {
                titleKey: 'canvas.size.socialMedia.twitter.header',
                width: 1500,
                height: 500,
                w: 3,
                h: 1,
            },
            {
                titleKey: 'canvas.size.socialMedia.twitter.card',
                width: 1200,
                height: 628,
                w: 1.91,
                h: 1,
            }
        ],
    },
    {
        key: 'youtube',
        titleKey: 'canvas.size.socialMedia.youtube',
        lists: [
            {
                titleKey: 'canvas.size.socialMedia.youtube.thumbnail',
                width: 1280,
                height: 720,
                w: 16,
                h: 9,
            },
            {
                titleKey: 'canvas.size.socialMedia.youtube.channel',
                width: 2560,
                height: 1440,
                w: 16,
                h: 9,
            },
            {
                titleKey: 'canvas.size.socialMedia.youtube.short',
                width: 1080,
                height: 1920,
                w: 9,
                h: 16,
            }
        ],
    },
    {
        key: 'linkedin',
        titleKey: 'canvas.size.socialMedia.linkedin',
        lists: [
            {
                titleKey: 'canvas.size.socialMedia.linkedin.post',
                width: 1200,
                height: 627,
                w: 1.91,
                h: 1,
            },
            {
                titleKey: 'canvas.size.socialMedia.linkedin.cover',
                width: 1584,
                height: 396,
                w: 4,
                h: 1,
            },
            {
                titleKey: 'canvas.size.socialMedia.linkedin.article',
                width: 1200,
                height: 627,
                w: 1.91,
                h: 1,
            }
        ],
    },
];
